import { CounterOfferGroupsView } from "../../components/counter-offer-groups/counter-offer-groups-view";
import { useCounterOfferGroups } from "../../components/counter-offer-groups/use-counter-offer-groups";

export const ReceivedCounterOffersList = () => {
  const logic = useCounterOfferGroups();
  return <CounterOfferGroupsView {...logic} />;
};
